import React from 'react';

import Label from '../ui/label/Label';
import DatePicker from '../ui/inputs/datePicker/DatePicker';
import PropTypes from 'prop-types';

const CommonDatePickerFilter = (props) => {

    const handleChange = (data) => {
        if (props.onChange) {
            props.onChange(data, props.dataField);
        }
    }

    return (
        <div className="input-label-part">
            <Label labelName={props.label} />
            <DatePicker
                id={props.dataField}
                selected={props.value}
                placeholder={props.placeholder}
                onChange={handleChange}
                isDisable={props.isDisable}
            />
        </div>
    )
}

CommonDatePickerFilter.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.instanceOf(Date),
    placeholder: PropTypes.string,
    dataField: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    isDisable: PropTypes.bool
};

export default CommonDatePickerFilter;